export const MultistepConfigMapping = {
  ALIAS: 'alias',
  CUSTOMER: 'customer',
  TECHINICIAN: 'technician',
  TEST_TYPE: 'testType',
  RUN_TYPE: 'runType',
  AGENT_TYPE: 'agentType',
  SCHEDULER: 'scheduler',
  SLECTED_APP: 'selectedApp',
  SELECTED_ORIGINATOR: 'selectedOriginator',
  SELECTED_APP_ID: 'selectedAppId',
  INTERVAL: 'interval',
  PROXY_CONFIG: 'proxyConfig',
  TEST_NAME: 'testName',
  SCRIPT_URL: 'scriptUrl',
  SCRIPT_NAME: 'scriptName',
  PAGE_URL: 'pageUrl'
};

export const MULTISTEP_AGENT_MODEL_CONFIG = {
  id: 'multistep_test',
  agentConfig: {
    default: {
      setup: {
        alias: {
          enabled: true,
          value: 'Multistep',
          outputField: MultistepConfigMapping.ALIAS,
          tabId: 'multistep_setup'
        },
        customer: {
          enabled: true,
          value: '',
          outputField: MultistepConfigMapping.CUSTOMER,
          tabId: 'multistep_setup',
          outputOptional: true
        },
        technician: {
          enabled: true,
          value: '',
          outputField: MultistepConfigMapping.TECHINICIAN,
          tabId: 'multistep_setup',
          outputOptional: true
        },
        runType: {
          enabled: true,
          value: 'on-going',
          outputField: MultistepConfigMapping.RUN_TYPE,
          tabId: 'multistep_setup'
        },
        agentType: {
          enabled: true,
          value: 'default',
          outputField: MultistepConfigMapping.AGENT_TYPE,
          tabId: 'multistep_setup'
        },
        scheduler: {
          enabled: true,
          value: { repeatInterval: 0, timeStamp: 'now', isValid: true },
          outputField: MultistepConfigMapping.SCHEDULER,
          tabId: 'multistep_setup'
        },
        interval: {
          enabled: true,
          value: 300,
          outputField: MultistepConfigMapping.INTERVAL,
          tabId: 'multistep_setup'
        },
        selectedOriginator: {
          enabled: true,
          value: null,
          outputField: MultistepConfigMapping.SELECTED_ORIGINATOR,
          tabId: 'multistep_setup'
        },
        selectedApp: {
          enabled: true,
          value: null,
          outputField: MultistepConfigMapping.SLECTED_APP,
          tabId: 'multistep_setup'
        },
        selectedAppId: {
          enabled: true,
          value: null,
          outputField: MultistepConfigMapping.SELECTED_APP_ID,
          tabId: 'multistep_setup',
          outputOptional: true
        },
        scriptUrl: {
          enabled: true,
          value: '',
          outputField: MultistepConfigMapping.SCRIPT_URL,
          tabId: 'multistep_setup',
          outputOptional: true
        },
        scriptName: {
          enabled: true,
          value: '',
          outputField: MultistepConfigMapping.SCRIPT_NAME,
          tabId: 'multistep_setup',
          outputOptional: true
        },
        pageUrl: {
          enabled: true,
          value: '',
          outputField: MultistepConfigMapping.PAGE_URL,
          tabId: 'multistep_setup',
          outputOptional: true
        },
        proxyConfig: {
          enabled: true,
          value: [
            {
              key: 'web-proxy',
              value: '{"config":{"useDefault":true,"protocol":null,"address":null,"port":null}}'
            }
          ],
          outputField: MultistepConfigMapping.PROXY_CONFIG,
          tabId: 'multistep_advanced',
          outputOptional: true
        }
      },

      running: {
        add: 'anything that is different between agents in running view'
      },

      final: {
        add: 'anything that is different between agents in final report'
      }
    }
  }
};
